import * as yup from "yup";

export const surveyYupSchema = yup.object().shape({
    firstname: yup.string().required('First name is required').transform((value) => (value ? value.trim() : '')),
    lastname: yup.string().required('Last name is required').transform((value) => (value ? value.trim() : '')),
    email: yup.string().required('Email is required').email("Please enter a valid email address").transform((value) => (value ? value.trim() : '')),
    answer: yup.string().max(300),
});